import(/* webpackMode: "eager" */ "/Users/gbcimac08/Documents/GitHub/website-v1/src/app/services/xlnc-a/_sections/xlnca.tsx")